import {
  categories_tab,
  menus_tab,
  modifier_groups_tab,
  modifiers_tab,
  products_tab,
} from '../../../../../../views/menu/smart-pricing';
import { SMART_PRICING_RESOURCE_TYPE } from '../../../../../../services/exports/Constants';

export default {
  title: 'Älykäs hinnoittelu',
  master_title: 'Brändi-tila - Älykäs hinnoittelu',
  sections: {
    how_it_works: {
      title: 'Miten se toimii',
      description:
        'Älykäs hinnoittelu on ominaisuus, jonka avulla voit hallita hintoja asiakkaan käyttämän tilaustavan perusteella. Tämä kattaa useita käyttötapauksia, kuten hinnan alentamisen noudolle, hinnan korottamisen toimitukselle, alennuksen lisäämisen kausivalikkoon jne. Voit luoda sääntöjä useilla tasoilla (Yleinen, Valikko, Kategoria, Tuote, Lisäkeryhmä, Lisäke). Tasot toimivat puumaisesti: korkeampi taso vaikuttaa alempiin tasoihin. Samalla alemman tason säännöllä on suurempi prioriteetti kuin ylemmän tason säännöllä (esim. 5 %:n nouto-alennus tietyssä kategoriassa korvaa yleisen 15 %:n nouto-alennuksen sen tuotteille).',
    },
  },
  tabs: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Yleiset säännöt',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Yleiset säännöt',
    [menus_tab]: 'Valikkosäännöt',
    [categories_tab]: 'Kategoriasäännöt',
    [products_tab]: 'Tuotesäännöt',
    [modifier_groups_tab]: 'Lisäkeryhmäsäännöt',
    [modifiers_tab]: 'Lisäkesäännöt',
  },
  fields: {
    name: 'Nimi',
    order_methods: 'Tilaustavat',
    modifier: 'Lisäke',
    image: 'Kuva',
    actions: 'Toiminnot',
  },
  labels: {
    absolute: 'Kiinteä',
  },
  buttons: {
    add_rule: 'Lisää sääntö',
    edit: 'Muokkaa',
    delete: 'Poista ({{count}})',
    images: 'Hallinnoi kuvaa',
  },
  popups: {
    delete_rule: {
      title: 'Haluatko varmasti poistaa?',
    },
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_delete: 'Sääntöjen poistaminen epäonnistui',
    deleted_successfully: 'Säännöt poistettu onnistuneesti',
  },
};
